/** Longest path from any root, over forward (upstream) adjacency. */
export function computeDepthFromForward(N, forward) {
  const memo = new Array(N).fill(-1);
  const visiting = new Set();
  function dfs(i) {
    if (memo[i] !== -1) return memo[i];
    if (visiting.has(i)) return 0;
    visiting.add(i);
    let max = -1;
    for (const parent of forward[i]) max = Math.max(max, dfs(parent));
    visiting.delete(i);
    memo[i] = max + 1;
    return memo[i];
  }
  for (let i = 0; i < N; i += 1) if (memo[i] === -1) dfs(i);
  return memo;
}

/** Longest path to any leaf, over reverse (dependent) adjacency. */
export function computeDepthToLeaf(N, reverse) {
  const memo = new Array(N).fill(-1);
  const visiting = new Set();
  function dfs(i) {
    if (memo[i] !== -1) return memo[i];
    if (visiting.has(i)) return 0;
    visiting.add(i);
    let max = 0;
    for (const j of reverse[i]) max = Math.max(max, dfs(j) + 1);
    visiting.delete(i);
    memo[i] = max;
    return max;
  }
  for (let i = 0; i < N; i += 1) if (memo[i] === -1) dfs(i);
  return memo;
}
